import './button.css'
export default function Button({ children, onClick, variant = "primary", icon: Icon, type = "button", disabled,style }){
    return(
        <button 
            type={type}
            className={`btn btn-${variant}`} 
            style={{...style}}
            onClick={onClick}
            disabled={disabled}
            >
            {Icon && <Icon size={18} />}
            {children}
        </button>
    )
}
